import { render, staticRenderFns } from "./noteList.vue?vue&type=template&id=4d473f1a&scoped=true"
import script from "./noteList.vue?vue&type=script&lang=js"
export * from "./noteList.vue?vue&type=script&lang=js"
import style0 from "./noteList.vue?vue&type=style&index=0&id=4d473f1a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d473f1a",
  null
  
)

export default component.exports